import React from "react";

// Size mapping
const sizeMap = {
  es: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 26,
};

export const DownloadIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="16"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 16)"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 14)"
      />
      <rect
        width="2"
        height="4"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 14 14)"
      />
      <rect
        width="2"
        height="12"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 7 12)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 5 10)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 3 8)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 9 10)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 11 8)"
      />
    </svg>
  );
};
export const UploadIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 13 12"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="12"
        height="1.5"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 12)"
      />
      <rect
        width="1.5"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 10.5)"
      />
      <rect
        width="1.5"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 11 10.5)"
      />
      <rect
        width="1.5"
        height="9"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 5.75 9)"
      />
      <rect
        width="1.5"
        height="1.5"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 4.25 2.5)"
      />
      <rect
        width="1.5"
        height="1.5"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 2.75 4)"
      />
      <rect
        width="1.5"
        height="1.5"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 7.25 2.5)"
      />
      <rect
        width="1.5"
        height="1.5"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 8.75 4)"
      />
    </svg>
  );
};
export const CalenderIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="12"
        height="2"
        transform="matrix(1 -5.82819e-08 -1.31134e-07 -1 2 16)"
      />
      <rect
        width="12"
        height="2"
        transform="matrix(1 -5.82819e-08 -1.31134e-07 -1 2 4)"
      />
      <rect
        width="4"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 4 0)"
      />
      <rect
        width="2"
        height="8"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 4 6)"
      />
      <rect
        width="4"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10 0)"
      />
      <rect
        width="2"
        height="10"
        transform="matrix(1 -6.99382e-08 -1.09278e-07 -1 0 14)"
      />
      <rect
        width="2"
        height="10"
        transform="matrix(1 -1.04907e-07 -7.28523e-08 -1 14 14)"
      />
    </svg>
  );
};
export const CalenderIcon2 = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="12"
        height="2"
        transform="matrix(1 -5.82819e-08 -1.31134e-07 -1 2 16)"
      />
      <rect
        width="12"
        height="2"
        transform="matrix(1 -5.82819e-08 -1.31134e-07 -1 2 4)"
      />
      <rect
        width="4"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 4 0)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 4 6)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 4 9)"
      />
      <rect
        width="4"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10 0)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 7 6)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 7 9)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10 6)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10 9)"
      />
      <rect
        width="2"
        height="10"
        transform="matrix(1 -6.99382e-08 -1.09278e-07 -1 0 14)"
      />
      <rect
        width="2"
        height="10"
        transform="matrix(1 -1.04907e-07 -7.28523e-08 -1 14 14)"
      />
    </svg>
  );
};
export const ArrowDown = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 15 10"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="3"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 3 6.5)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 6 9.5)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 3.5)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 9 6.5)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 12 3.5)"
      />
    </svg>
  );
};
export const ArrowUp = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 20 12"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="4" height="4" />
      <rect x="8" width="4" height="4" />
      <rect y="8" width="4" height="4" />
      <rect x="12" y="4" width="4" height="4" />
      <rect x="16" y="8" width="4" height="4" />
    </svg>
  );
};
export const ArrowRight = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 9 15"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 6 12)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 9 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 3 15)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 6 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 3 3)"
      />
    </svg>
  );
};
export const DoubleArrowRight = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 19 15"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 6 12)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 9 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 3 15)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 6 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 3 3)"
      />

      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 15 12)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 18 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 12 15)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 15 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(-1.31134e-07 -1 -1 1.31134e-07 12 3)"
      />
    </svg>
  );
};
export const ArrowLeft = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 9 15"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 3 3)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 6 0)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 3 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 6 12)"
      />
    </svg>
  );
};
export const DoubleArrowLeft = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 19 15"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 3 3)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 6 0)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 3 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 6 12)"
      />

      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 12 3)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 9 6)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 15 0)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 12 9)"
      />
      <rect
        width="3"
        height="3"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 15 12)"
      />
    </svg>
  );
};
export const TickRight = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2" y="8" width="2" height="2" />
      <rect x="2" y="10" width="2" height="2" />
      <rect x="0" y="8" width="2" height="2" />
      <rect x="0" y="6" width="2" height="2" />
      <rect x="4" y="10" width="2" height="2" />
      <rect x="4" y="12" width="2" height="2" />
      <rect x="6" y="10" width="2" height="2" />
      <rect x="8" y="8" width="2" height="2" />
      <rect x="10" y="6" width="2" height="2" />
      <rect x="12" y="4" width="2" height="2" />
      <rect x="14" y="2" width="2" height="2" />
      <rect x="6" y="8" width="2" height="2" />
      <rect x="8" y="6" width="2" height="2" />
      <rect x="10" y="4" width="2" height="2" />
      <rect x="12" y="2" width="2" height="2" />
      <rect x="14" y="0" width="2" height="2" />
    </svg>
  );
};
export const Minus = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0" y="7" width="2" height="2" />
      <rect x="0" y="8" width="2" height="2" />
      <rect x="2" y="7" width="2" height="2" />
      <rect x="2" y="8" width="2" height="2" />
      <rect x="4" y="7" width="2" height="2" />
      <rect x="4" y="8" width="2" height="2" />
      <rect x="6" y="7" width="2" height="2" />
      <rect x="6" y="8" width="2" height="2" />
      <rect x="8" y="7" width="2" height="2" />
      <rect x="8" y="8" width="2" height="2" />
      <rect x="10" y="7" width="2" height="2" />
      <rect x="10" y="8" width="2" height="2" />
      <rect x="12" y="7" width="2" height="2" />
      <rect x="12" y="8" width="2" height="2" />
      <rect x="14" y="7" width="2" height="2" />
      <rect x="14" y="8" width="2" height="2" />
      <rect x="16" y="7" width="2" height="2" />
      <rect x="16" y="8" width="2" height="2" />
    </svg>
  );
};
export const Info = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="9" y="6.5" width="2" height="2" transform="rotate(180 9 6.5)" />
      <rect x="9" y="8.5" width="4" height="1" transform="rotate(180 9 8.5)" />
      <rect
        x="9"
        y="12.5"
        width="2"
        height="4"
        transform="rotate(180 9 12.5)"
      />
      <rect x="4" y="4.5" width="2" height="2" transform="rotate(180 4 4.5)" />
      <rect
        x="12"
        y="2.5"
        width="8"
        height="2"
        transform="rotate(180 12 2.5)"
      />
      <rect x="2" y="4.5" width="8" height="2" transform="rotate(90 2 4.5)" />
      <rect x="16" y="4.5" width="8" height="2" transform="rotate(90 16 4.5)" />
      <rect
        x="12"
        y="16.5"
        width="8"
        height="2"
        transform="rotate(180 12 16.5)"
      />
      <rect
        x="14"
        y="4.5"
        width="2"
        height="2"
        transform="rotate(180 14 4.5)"
      />
      <rect
        x="4"
        y="14.5"
        width="2"
        height="2"
        transform="rotate(180 4 14.5)"
      />
      <rect
        x="14"
        y="14.5"
        width="2"
        height="2"
        transform="rotate(180 14 14.5)"
      />
    </svg>
  );
};
export const Eye = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 5H13V6H14V7H15V8H16V9H15V10H14V11H13V12H12V13H4V12H3V11H2V10H1V9H0V8H1V7H2V6H3V5H4V4H6V3H10V4H12V5ZM3 8H2V9H3V10H4V11H5V12H11V11H12V10H13V9H14V8H13V7H11V8H10V10H6V8H5V7H3V8Z" />
    </svg>
  );
};
export const Verified = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="12" width="2" height="10" transform="rotate(180 4 12)" />
      <rect x="12" y="14" width="8" height="14" transform="rotate(180 12 14)" />
      <rect x="2" y="4" width="8" height="2" transform="rotate(90 2 4)" />
      <rect x="16" y="4" width="8" height="2" transform="rotate(90 16 4)" />
      <rect x="12" y="16" width="8" height="2" transform="rotate(180 12 16)" />
      <rect x="14" y="12" width="2" height="10" transform="rotate(180 14 12)" />
      <rect x="4" y="14" width="2" height="2" transform="rotate(180 4 14)" />
      <rect x="14" y="14" width="2" height="2" transform="rotate(180 14 14)" />
      <path
        d="M13 6H12V7H11V8H10V9H9V10H8V11H7V12H5V11H4V10H3V8H5V9H7V8H8V7H9V6H10V5H11V4H13V6Z"
        fill="#191919"
      />
    </svg>
  );
};
export const Magnifier = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="4.06546"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 1.23438 3.61523)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 2.04492 1.99219)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 2.04492 7.68359)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 3.67383 1.17578)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 7.73828 1.17578)"
      />
      <rect
        width="1.62619"
        height="2.43928"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 5.29883 0.365234)"
      />
      <rect
        width="1.62619"
        height="2.43928"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 5.29883 9.31055)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 3.67383 8.49609)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 7.73828 8.49609)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 9.36523 9.31055)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10.1797 9.31055)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10.1797 10.123)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10.9922 10.123)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10.9922 10.9355)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 11.8047 10.9355)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 11.8047 11.75)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 12.6191 11.75)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 12.6191 12.5605)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 13.4297 12.5605)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 13.4297 13.375)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 9.36523 1.99219)"
      />
      <rect
        width="1.62619"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 9.36523 7.68359)"
      />
      <rect
        width="4.06546"
        height="1.62619"
        transform="matrix(-4.37114e-08 1 1 -2.91409e-08 10.1797 3.61523)"
      />
    </svg>
  );
};
export const Clock = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="9" y="9" width="2" height="5" transform="rotate(180 9 9)" />
      <rect x="10" y="10" width="2" height="2" transform="rotate(180 10 10)" />
      <rect x="11" y="11" width="2" height="2" transform="rotate(180 11 11)" />
      <rect x="4" y="4" width="2" height="2" transform="rotate(180 4 4)" />
      <rect x="12" y="2" width="8" height="2" transform="rotate(180 12 2)" />
      <rect x="2" y="4" width="8" height="2" transform="rotate(90 2 4)" />
      <rect x="16" y="4" width="8" height="2" transform="rotate(90 16 4)" />
      <rect x="12" y="16" width="8" height="2" transform="rotate(180 12 16)" />
      <rect x="14" y="4" width="2" height="2" transform="rotate(180 14 4)" />
      <rect x="4" y="14" width="2" height="2" transform="rotate(180 4 14)" />
      <rect x="14" y="14" width="2" height="2" transform="rotate(180 14 14)" />
    </svg>
  );
};
export const Close = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1" y="1" width="2.80012" height="2.80001" />
      <rect x="1" y="12.2002" width="2.80012" height="2.80001" />
      <rect x="3.80078" y="3.7998" width="2.80012" height="2.80001" />
      <rect x="3.80078" y="9.40039" width="2.80012" height="2.80001" />
      <rect x="6.60107" y="6.60059" width="2.80012" height="2.80001" />
      <rect x="9.39941" y="9.40039" width="2.80012" height="2.80001" />
      <rect x="9.39941" y="3.7998" width="2.80012" height="2.80001" />
      <rect x="12.1997" y="12.2002" width="2.80012" height="2.80001" />
      <rect x="12.1997" y="1" width="2.80012" height="2.80001" />
    </svg>
  );
};
export const StashBoard = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3" y="21" width="18" height="3" />
      <rect x="3" width="18" height="3" />
      <rect x="10.5" y="3" width="3" height="18" />
      <rect x="13.5" y="9" width="7.5" height="3" />
      <rect y="3" width="3" height="18" />
      <rect x="21" y="3" width="3" height="18" />
    </svg>
  );
};
export const Vision = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="24"
        width="1.5"
        height="16.5"
        transform="rotate(180 1.5 24)"
      />
      <rect
        x="6"
        y="24"
        width="1.5"
        height="16.5"
        transform="rotate(180 6 24)"
      />
      <rect
        x="10.5"
        y="24"
        width="1.5"
        height="22.5"
        transform="rotate(180 10.5 24)"
      />
      <rect
        x="15"
        y="24"
        width="1.5"
        height="22.5"
        transform="rotate(180 15 24)"
      />
      <rect
        x="19.5"
        y="24"
        width="1.5"
        height="12"
        transform="rotate(180 19.5 24)"
      />
      <rect
        x="24"
        y="24"
        width="1.5"
        height="12"
        transform="rotate(180 24 24)"
      />
      <rect
        x="4.5"
        y="7.5"
        width="3"
        height="1.5"
        transform="rotate(180 4.5 7.5)"
      />
      <rect
        x="4.5"
        y="24"
        width="3"
        height="13.5"
        transform="rotate(180 4.5 24)"
      />
      <rect
        x="13.5"
        y="1.5"
        width="3"
        height="1.5"
        transform="rotate(180 13.5 1.5)"
      />
      <rect
        x="13.5"
        y="24"
        width="3"
        height="19.5"
        transform="rotate(180 13.5 24)"
      />
      <rect
        x="22.5"
        y="12"
        width="3"
        height="1.5"
        transform="rotate(180 22.5 12)"
      />
      <rect
        x="22.5"
        y="24"
        width="3"
        height="9"
        transform="rotate(180 22.5 24)"
      />
    </svg>
  );
};
export const Block = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1.5" y="1.5" width="3" height="3" />
      <rect x="6" y="6" width="3" height="3" />
      <rect x="7.5" y="4.5" width="9" height="3" />
      <rect width="3" height="3" transform="matrix(1 0 0 -1 6 18)" />
      <rect width="3" height="3" transform="matrix(-1 0 0 1 18 6)" />
      <rect width="9" height="3" transform="matrix(1 0 0 -1 7.5 19.5)" />
      <rect width="3" height="3" transform="matrix(-1 0 0 1 22.5 1.5)" />
      <rect x="18" y="18" width="3" height="3" transform="rotate(180 18 18)" />
      <rect x="15" y="12" width="3" height="3" transform="rotate(180 15 12)" />
      <rect
        x="22.5"
        y="22.5"
        width="3"
        height="3"
        transform="rotate(180 22.5 22.5)"
      />
      <rect width="3" height="3" transform="matrix(1 0 0 -1 1.5 22.5)" />
      <rect width="3" height="9" transform="matrix(1 0 0 -1 16.5 16.5)" />
      <rect width="3" height="9" transform="matrix(1 0 0 -1 4.5 16.5)" />
      <rect y="3" width="3" height="4.5" />
      <rect width="3" height="4.5" transform="matrix(-1 0 0 1 24 3)" />
      <rect
        x="24"
        y="21"
        width="3"
        height="4.5"
        transform="rotate(180 24 21)"
      />
      <rect width="3" height="4.5" transform="matrix(1 0 0 -1 0 21)" />
      <rect x="3" width="4.5" height="3" />
      <rect width="4.5" height="3" transform="matrix(-1 0 0 1 21 0)" />
      <rect
        x="21"
        y="24"
        width="4.5"
        height="3"
        transform="rotate(180 21 24)"
      />
      <rect width="4.5" height="3" transform="matrix(1 0 0 -1 3 24)" />
    </svg>
  );
};
export const Filter = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_573_4789"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" />
      </mask>
      <g mask="url(#mask0_573_4789)">
        <path d="M9.33333 20V17.3333H14.6667V20H9.33333ZM4 13.3333V10.6667H20V13.3333H4ZM0 6.66667V4H24V6.66667H0Z" />
      </g>
    </svg>
  );
};
export const Play = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 3H7V4H8V5H9V6H10V7H11V9H10V10H9V11H8V12H7V13H6V14H5V2H6V3Z" />
    </svg>
  );
};
export const Pause = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 2H7V14H6V15H5V14H4V2H5V1H6V2Z" />
      <path d="M11 1V2H12V14H11V15H10V14H9V2H10V1H11Z" />
    </svg>
  );
};
export const EllipsisH = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 7 9)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 3 9)"
      />
      <rect
        width="2"
        height="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 11 9)"
      />
    </svg>
  );
};
export const AddUser = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="8.33521" y="6.39844" width="2.13295" height="2.13295" />
      <rect x="6.19714" y="5.33569" width="2.13295" height="2.13295" />
      <rect x="5.13281" y="3.19775" width="2.13295" height="2.13295" />
      <rect x="2.00006" y="5" width="1" height="5" />
      <rect
        x="5.00006"
        y="7"
        width="1"
        height="5"
        transform="rotate(90 5.00006 7)"
      />
      <rect x="6.19714" y="1.06763" width="2.13295" height="2.13295" />
      <rect x="8.33521" width="2.13295" height="2.13295" />
      <rect x="10.4656" y="1.06763" width="2.13295" height="2.13295" />
      <rect x="11.5327" y="3.198" width="2.13295" height="2.13295" />
      <rect x="10.4656" y="5.33569" width="2.13295" height="2.13295" />
      <rect x="4.06677" y="11.7314" width="10.6663" height="2.13327" />
      <rect x="2.99963" y="13.8667" width="12.7996" height="2.13327" />
      <rect x="5.13196" y="9.60107" width="8.53308" height="2.13327" />
    </svg>
  );
};
export const Edit = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="2.53333"
        height="20.2667"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 1.86719 19.4666)"
      />
      <rect
        width="3.8"
        height="3.8"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 4.40051 16.9333)"
      />
      <rect
        width="3.8"
        height="3.8"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 5.66718 15.6667)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 9.46716 11.8667)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 10.7338 10.6001)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 12.0005 9.33325)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 13.2672 8.06665)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 14.5339 6.80005)"
      />
      <rect
        width="2.53333"
        height="2.53333"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 15.8005 5.53345)"
      />
    </svg>
  );
};
export const Share = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.6924 6.11523H19.3076V12.6543H16.6924V15.2695H14.0771V11.3457H12.7695V12.6543H10.1543V13.9619H7.53809V15.2695H6.23047V17.8848H4.92285V20.5H1V17.8848H2.30762V15.2695H3.61523V12.6543H4.92285V11.3457H6.23047V10.0381H8.8457V8.73047H11.4619V7.42285H14.0771V3.5H16.6924V6.11523ZM21.9238 7.42285V11.3457H19.3086V7.42285H21.9238Z" />
    </svg>
  );
};
export const Save = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.75 21H5.25V18.75H18.75V21ZM18.75 5.25H16.5V10.875H7.5V5.25H5.25V18.75H3V5.25H5.25V3H18.75V5.25ZM21 5.25V18.75H18.75V5.25H21ZM8.625 8.625H10.875V5.25H8.625V8.625Z" />
    </svg>
  );
};
export const Trash = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.40039 5.59961V13.5996H5.2002V14.4004H11.5996V13.5996H12.4004V5.59961H4.40039ZM11.5996 0.799805H14V1.59961H14.7998V3.2002H2V1.59961H2.7998V0.799805H5.2002V0H11.5996V0.799805ZM14 14.4004H13.2002V15.2002H12.4004V16H4.40039V15.2002H3.59961V14.4004H2.7998V4H14V14.4004Z" />
    </svg>
  );
};
export const Trash2 = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 54 74"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M50.6201 66.376H47.2432V69.752H43.873V73.126H10.123V69.752H6.74316V66.376H3.37305V29.252H3.37012V22.502H50.6201V66.376ZM10.123 63.002H13.4932V66.376H40.4932V63.002H43.8701V29.252H38.252V66.375H33.752V29.252H29.248V66.375H24.748V29.252H20.25V66.375H15.75V29.252H10.123V63.002ZM50.6201 12.377H54V19.127H0V12.377H3.37012V9.00195H50.6201V12.377ZM40.4951 9H13.4951V5.625H40.4951V9ZM30.375 4.5H22.5V0H30.375V4.5Z" />
    </svg>
  );
};
export const WarningIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="7" y="4" width="2" height="2" />
      <rect x="6" y="1" width="4" height="2" />
      <rect x="5" y="3" width="6" height="2" />
      <rect x="4" y="5" width="8" height="2" />
      <rect x="3" y="7" width="10" height="2" />
      <rect x="2" y="9" width="12" height="2" />
      <rect x="1" y="11" width="14" height="2" />
      <rect y="13" width="16" height="2" />
      <rect x="7" y="11" width="2" height="2" fill="#191919" />
      <rect x="7" y="3" width="2" height="7" fill="#191919" />
    </svg>
  );
};
export const Danger = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="7" y="9" width="2" height="2" />
      <rect x="5" y="8" width="2" height="2" />
      <rect x="4" y="6" width="2" height="2" />
      <rect x="5" y="4" width="2" height="2" />
      <rect x="7" y="3" width="2" height="2" />
      <rect x="9" y="4" width="2" height="2" />
      <rect x="10" y="6" width="2" height="2" />
      <rect x="9" y="8" width="2" height="2" />
      <rect x="2" y="14" width="12" height="2" />
      <rect x="4" y="12" width="8" height="2" />
      <rect width="2" height="2" transform="matrix(-1 0 0 1 15 1)" />
      <rect x="1" y="1" width="2" height="2" />
      <rect width="2" height="3" transform="matrix(-1 0 0 1 16 2)" />
      <rect y="2" width="2" height="3" />
      <rect width="3" height="2" transform="matrix(-1 0 0 1 14 0)" />
      <rect x="2" width="3" height="2" />
    </svg>
  );
};
export const Rating = ({
  rating = 0,
  size = "md",
  max = 5,
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  // heart rating logic

  const full = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.25 && rating % 1 < 0.75;
  const hearts = [];

  for (let i = 0; i < max; i++) {
    if (i < full) {
      hearts.push("full");
    } else if (i === full && hasHalf) {
      hearts.push("half");
    } else {
      hearts.push("empty");
    }
  }

  // color logic

  const getColorByRating = (rating) => {
    if (rating === 0) return "transparent";
    if (rating < 2) return "#FF0000";
    if (rating < 3) return "#FF8800";
    if (rating < 4) return "#FFCC00";
    return "#34C759";
  };

  const dynamicColor = getColorByRating(rating);
  return (
    <div className="heart-rating" style={{ display: "flex", gap: "4px" }}>
      {hearts.map((type, index) => {
        return (
          <div className="heart" key={index}>
            <svg
              viewBox="0 0 16 16"
              width={iconSize}
              height={iconSize}
              fill={color}
              className={`icon ${className}`}
              xmlns="http://www.w3.org/2000/svg"
              {...props}
            >
              {type === "half" ? (
                <>
                  <path
                    d="M15,4v-1h-1v-1h-1v-1h-3v1h-1v1h-2v-1h-1v-1h-3v1h-1v1h-1v1H0v4h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-4h-1ZM14,7h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-2h1v-1h1v-1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v1h1v1h1v2Z"
                    fill="#F3F3F3"
                  />
                  <polygon
                    points="9 6 9 12 7 12 7 11 6 11 6 10 5 10 5 9 4 9 4 8 3 8 3 7 2 7 2 5 3 5 3 4 4 4 4 3 5 3 5 4 6 4 6 5 7 5 7 6 9 6"
                    fill={dynamicColor}
                  />
                </>
              ) : (
                <>
                  <path
                    d="M15,4v-1h-1v-1h-1v-1h-3v1h-1v1h-2v-1h-1v-1h-3v1h-1v1h-1v1H0v4h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-4h-1ZM14,7h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-2h1v-1h1v-1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v1h1v1h1v2Z"
                    fill="#F3F3F3"
                  />

                  {type === "full" ? (
                    <polygon
                      points="14 5 14 7 13 7 13 8 12 8 12 9 11 9 11 10 10 10 10 11 9 11 9 12 7 12 7 11 6 11 6 10 5 10 5 9 4 9 4 8 3 8 3 7 2 7 2 5 3 5 3 4 4 4 4 3 5 3 5 4 6 4 6 5 7 5 7 6 9 6 9 5 10 5 10 4 11 4 11 3 12 3 12 4 13 4 13 5 14 5"
                      fill={dynamicColor}
                    />
                  ) : (
                    ""
                  )}
                </>
              )}
            </svg>
          </div>
        );
      })}
    </div>
  );
};
export const Location = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 20 20"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="16" y="5" width="5" height="2" transform="rotate(90 16 5)" />
      <rect x="14" y="5" width="3" height="1" transform="rotate(90 14 5)" />
      <rect x="5" y="5" width="3" height="1" />
      <rect x="13" y="5" width="1" height="1" transform="rotate(90 13 5)" />
      <rect x="7" y="6" width="5" height="2" transform="rotate(90 7 6)" />
      <rect x="15" y="4" width="1" height="9" transform="rotate(90 15 4)" />
      <rect x="12" y="3" width="2" height="2" transform="rotate(90 12 3)" />
      <rect x="10" y="3" width="2" height="2" transform="rotate(90 10 3)" />
      <rect x="8" y="4" width="1" height="3" transform="rotate(90 8 4)" />
      <rect x="14" y="3" width="1" height="8" transform="rotate(90 14 3)" />
      <rect x="13" y="2" width="1" height="6" transform="rotate(90 13 2)" />
      <rect x="15" y="9" width="3" height="1" transform="rotate(90 15 9)" />
      <rect x="14" y="8" width="6" height="1" transform="rotate(90 14 8)" />
      <rect x="13" y="10" width="6" height="1" transform="rotate(90 13 10)" />
      <rect x="12" y="11" width="6" height="1" transform="rotate(90 12 11)" />
      <rect x="11" y="11" width="7" height="2" transform="rotate(90 11 11)" />
      <rect x="9" y="11" width="6" height="1" transform="rotate(90 9 11)" />
      <rect x="8" y="10" width="6" height="1" transform="rotate(90 8 10)" />
      <rect x="7" y="11" width="3" height="1" transform="rotate(90 7 11)" />
      <rect x="6" y="9" width="3" height="1" transform="rotate(90 6 9)" />
      <rect x="5" y="5" width="5" height="1" transform="rotate(90 5 5)" />
    </svg>
  );
};
export const LoadingIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 65 72"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M60.5 72H4.5V70H60.5V72ZM4.5 70H2.5V68H4.5V70ZM62.5 70H60.5V68H62.5V70ZM2.5 68H0.5V64H2.5V68ZM64.5 68H62.5V64H64.5V68ZM60.5 66H4.5V64H60.5V66ZM4.5 64H2.5V62H4.5V64ZM62.5 64H60.5V62H62.5V64ZM6.5 62H4.5V56H6.5V62ZM34.5 60H36.5V62H28.5V60H30.5V58H34.5V60ZM60.5 62H58.5V56H60.5V62ZM8.5 56H6.5V52H8.5V56ZM33.5 56H31.5V54H33.5V56ZM58.5 56H56.5V52H58.5V56ZM10.5 52H8.5V48H10.5V52ZM56.5 52H54.5V48H56.5V52ZM33.5 51H31.5V49H33.5V51ZM12.5 48H10.5V46H12.5V48ZM54.5 48H52.5V46H54.5V48ZM14.5 46H12.5V42H14.5V46ZM56.5 14H54.5V18H52.5V22H50.5V24H48.5V28H46.5V30H42.5V32H40.5V35H39.5V37H38.5V39H36.5V42H35.5V44H34.5V46H30.5V44H29.5V42H28.5V39H26.5V37H25.5V35H24.5V32H22.5V30H18.5V28H16.5V24H14.5V22H12.5V18H10.5V14H8.5V12H56.5V14ZM52.5 46H50.5V42H52.5V46ZM16.5 42H14.5V40H16.5V42ZM50.5 42H48.5V40H50.5V42ZM20.5 40H16.5V38H20.5V40ZM48.5 40H44.5V38H48.5V40ZM22.5 38H20.5V34H22.5V38ZM44.5 38H42.5V34H44.5V38ZM20.5 34H16.5V32H20.5V34ZM48.5 34H44.5V32H48.5V34ZM16.5 32H14.5V30H16.5V32ZM50.5 32H48.5V30H50.5V32ZM14.5 30H12.5V26H14.5V30ZM52.5 30H50.5V26H52.5V30ZM12.5 26H10.5V24H12.5V26ZM54.5 26H52.5V24H54.5V26ZM10.5 24H8.5V20H10.5V24ZM56.5 24H54.5V20H56.5V24ZM8.5 20H6.5V16H8.5V20ZM58.5 20H56.5V16H58.5V20ZM6.5 16H4.5V10H6.5V16ZM60.5 16H58.5V10H60.5V16ZM4.5 10H2.5V8H4.5V10ZM62.5 10H60.5V8H62.5V10ZM2.5 8H0.5V4H2.5V8ZM60.5 8H4.5V6H60.5V8ZM64.5 8H62.5V4H64.5V8ZM4.5 4H2.5V2H4.5V4ZM62.5 4H60.5V2H62.5V4ZM60.5 2H4.5V0H60.5V2Z" />
    </svg>
  );
};
export const LoadingSuccess = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 71 72"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M41.5 2H47.5V4H50.5V6H54.5V8H58.5V10H60.5V12H62.5V14H64.5V16H65.5V18H66.5V20H67.5V22H68.5V24H69.5V26H70.5V46H69.5V48H68.5V50H67.5V52H66.5V54H65.5V56H64.5V58H62.5V60H60.5V62H58.5V64H54.5V66H50.5V68H47.5V70H41.5V72H29.5V70H23.5V68H20.5V66H16.5V64H12.5V62H10.5V60H8.5V58H6.5V56H5.5V54H4.5V52H3.5V50H2.5V48H1.5V46H0.5V26H1.5V24H2.5V22H3.5V20H4.5V18H5.5V16H6.5V14H8.5V12H10.5V10H12.5V8H16.5V6H20.5V4H23.5V2H29.5V0H41.5V2ZM29.5 6H24.5V8H20.5V10H16.5V12H14.5V14H12.5V16H10.5V18H9.5V20H8.5V22H7.5V24H6.5V26H5.5V28H4.5V44H5.5V46H6.5V48H7.5V50H8.5V52H9.5V54H10.5V56H12.5V58H14.5V60H16.5V62H20.5V64H24.5V66H29.5V68H41.5V66H46.5V64H50.5V62H54.5V60H56.5V58H58.5V56H60.5V54H61.5V52H62.5V50H63.5V48H64.5V46H65.5V44H66.5V28H65.5V26H64.5V24H63.5V22H62.5V20H61.5V18H60.5V16H58.5V14H56.5V12H54.5V10H50.5V8H46.5V6H41.5V4H29.5V6ZM58.5 30H56.5V32H54.5V34H52.5V36H50.5V38H48.5V40H46.5V42H44.5V44H42.5V46H40.5V48H38.5V50H36.5V52H34.5V54H32.5V56H30.5V58H26.5V56H24.5V54H22.5V52H20.5V50H18.5V48H16.5V46H14.5V44H12.5V36H16.5V38H18.5V40H20.5V42H22.5V44H24.5V46H26.5V48H28.5V47H30.5V45H32.5V43H34.5V41H36.5V39H38.5V37H40.5V35H42.5V33H44.5V31H46.5V29H48.5V27H50.5V25H52.5V23H54.5V21H58.5V30Z" />
    </svg>
  );
};
export const Playback = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 11 12"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2 1H3V11H2V12H1V11H0V1H1V0H2V1ZM6 1H7V2H8V3H9V4H10V5H11V7H10V8H9V9H8V10H7V11H6V12H5V0H6V1Z" />
    </svg>
  );
};
export const LinkIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 10 10"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0.625 8.75H1.25V9.375H3.125V10H0.625V9.375H0V6.875H0.625V8.75ZM5.625 8.125H5V8.75H4.375V9.375H3.125V8.75H3.75V8.125H4.375V7.5H5V6.875H5.625V8.125ZM8.125 3.125H7.5V3.75H6.875V4.375H6.25V5H5.625V5.625H5V6.25H4.375V6.875H3.75V7.5H3.125V8.125H2.5V8.75H1.875V8.125H1.25V7.5H1.875V6.875H2.5V6.25H3.125V5.625H3.75V5H4.375V4.375H5V3.75H5.625V3.125H6.25V2.5H6.875V1.875H8.125V3.125ZM3.125 5H2.5V5.625H1.875V6.25H1.25V6.875H0.625V5.625H1.25V5H1.875V4.375H3.125V5ZM9.375 4.375H8.75V5H8.125V5.625H6.875V5H7.5V4.375H8.125V3.75H8.75V3.125H9.375V4.375ZM6.875 1.25H6.25V1.875H5.625V2.5H5V3.125H4.375V1.875H5V1.25H5.625V0.625H6.875V1.25ZM8.75 0.625H6.875V0H9.375V0.625H10V3.125H9.375V1.25H8.75V0.625Z" />
    </svg>
  );
};
export const FullScreen = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 20 20"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 15H3.75V13.75H5V12.5H6.25V11.25H8.75V13.75H7.5V15H6.25V16.25H5V17.5H8.75V20H0V11.25H2.5V15ZM20 8.75H17.5V5H16.25V6.25H15V7.5H13.75V8.75H11.25V6.25H12.5V5H13.75V3.75H15V2.5H11.25V0H20V8.75Z" />
    </svg>
  );
};
export const Copy = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14 14V16H6V14H14ZM6 14H2V12H4V5H6V14ZM16 14H14V5H16V14ZM2 12H0V2H2V12ZM11 11H8V10H11V11ZM13 9H7V8H13V9ZM13 7H7V6H13V7ZM12 3H14V5H6V3H10V2H12V3ZM10 2H2V0H10V2Z" />
    </svg>
  );
};
export const Shuffle = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 16 16"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.11133 0.889648H9.00098V1.77734H9.88965V3.55566H9.00098V4.44434H8.11133V5.33301H6.33301V3.55566H5.44434V4.44434H4.55469V5.33301H3.66699V6.22168H2.77734V8.88867H3.66699V9.77734H4.55469V11.5557H2.77734V10.667H1.88965V9.77832H1V5.33398H1.88965V4.44434H2.77734V3.55566H3.66699V2.66699H4.55664V1.77734H6.33301V0H8.11133V0.889648Z" />
      <path d="M8.10938 15.1104H7.22266V14.2227H6.33301V12.4443H7.22266V11.5557H8.10938V10.667H9.8877V12.4443H10.7764V11.5557H11.666V10.667H12.5557V9.77832H13.4434V7.11133H12.5557V6.22266H11.666V4.44434H13.4434V5.33301H14.333V6.22168H15.2207V10.666H14.333V11.5557H13.4434V12.4443H12.5537V13.333H11.667V14.2227H9.8877V16H8.10938V15.1104Z" />
    </svg>
  );
};
export const GoogleIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M23 10V15H22V17H21V19H20V20H19V21H17V22H15V23H9V22H7V21H5V20H4V19H3V17H2V15H1V9H2V7H3V5H4V4H5V3H7V2H9V1H15V2H17V3H19V5H18V6H17V7H15V6H9V7H7V9H6V15H7V17H9V18H15V17H17V15H18V14H12V10H23Z" />
    </svg>
  );
};
export const FacebookIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M23 9V15H22V17H21V19H20V20H19V21H17V22H15V23H14V15H16V14H17V12H14V9H15V8H17V5H13V6H11V8H10V12H7V15H10V23H9V22H7V21H5V20H4V19H3V17H2V15H1V9H2V7H3V5H4V4H5V3H7V2H9V1H15V2H17V3H19V4H20V5H21V7H22V9H23Z" />
    </svg>
  );
};
export const TwitterIcon = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 24 24"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M23 5H22V6H23V5Z" />
      <path d="M23 3H22V4H23V3Z" />
      <path d="M21 5V6H22V7H21V12H20V14H19V16H18V17H17V18H16V19H14V20H11V21H4V20H2V19H1V18H3V19H6V18H7V17H5V16H4V15H3V14H5V13H3V12H2V10H4V9H3V8H2V4H3V5H4V6H5V7H7V8H10V9H12V5H13V4H14V3H19V4H22V5H21Z" />{" "}
    </svg>
  );
};
export const Call = ({
  size = "md",
  color = "currentColor",
  className = "",
  ...props
}) => {
  // Get the numeric size value from the sizeMap, default to 'md' (16)
  const iconSize = sizeMap[size] || sizeMap.md;

  return (
    <svg
      viewBox="0 0 20 20"
      width={iconSize}
      height={iconSize}
      fill={color}
      className={`icon ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.4297 18.001H12.2871V12.2871H13.4297V18.001ZM12.2861 17.998H10V13.4268H12.2861V17.998ZM16.8584 12.2871H18V16.8584H16.8584V17.9971H13.4307V11.1396H16.8584V12.2871ZM7.71289 11.1396H8.85645V12.2871H9.99902V16.8584H8.85645V16.8545H7.71289V15.7139H6.57031V14.5693H5.42969V13.4297H4.28711V12.2871H6.57031V12.2861H3.14355V10H7.71289V11.1396ZM7.71484 3.13965H8.85645V6.56836H7.71289V7.71094H6.57129V9.99707H2V3.13965H3.14355V2H7.71484V3.13965Z" />
    </svg>
  );
};
